import React, { useEffect, useState } from "react";



import {  Link  } from "react-router-dom";
import myLogo from "./components/img/brush.png";
import './MenuBar.css'
import { AlignLeft ,Plus } from 'lucide-react';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useSelector } from "react-redux";
import Loading from "./components/Loading/Loading";

const MenuBar =()=>{
  const [isHovered, setIsHovered] = useState(false);
  const [loader , setLoader] =useState(false);
  const [loginPopUp , setLoginPopUp] =useState(true);
  
  const dispatch = useDispatch();
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
  

  const history = useHistory();
 
   
   const localToken= localStorage.getItem("profile");
   const token = useSelector((state)=>state?.user?.user?.token);
  
const data = useSelector((state)=>state?.user?.user);
const [loginStatus,setLoginStatus] = useState(false)
useEffect(()=>{
  data!==null?setLoginStatus(true):setLoginStatus(false);
},[])

  const logOut =() =>{

    dispatch({type:"LOGOUT"});
    setLoginStatus(false);
    history.push('')
  }
 
return<>

{<Loading  Load={loader?.status}/>}
 <div  className="menuOuter">
 
 <div className="TopLeftNavLogo" style={{float:'left',position: 'relative',top: '12px','paddingRight':'15px'}}>
  
{(token===localToken&&token&&localToken)?
  <>
 <Link to="/"> <Plus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  color="#958FDA" size={30} /></Link> 
</>  :<> <Link to="/"> <Plus onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  color="#958FDA" size={30} /></Link> </>}

 </div>
 <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="TopLeftNavLogo" style={{float:'left',position: 'relative',top: '15px'}}> </div>
          

              <div  className="TopLeftNavName" key="1">
                <Link  style={{ float:'left'
    ,padding:'5px 15px',
  textDecoration: 'none',
  position: 'relative',
  top: '2px',
  fontSize: '26px',
  border: '0px',
  fontWeight: 'bold',
  background: 'linear-gradient(270deg, #E02CD3 20.56%, #6243EB 56.63%, #0952FF 69.98%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}}  to="">
               
                <span onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  > <img src={"https://i.postimg.cc/7Zwy3WW9/Testprism_Logo.png"}  style={{ "width":"170px",}}alt="User"/></span>
                </Link> 
            
                
             
             
              </div>
              <div className="navbar-menu-outer" >
             {data?.currentToken==null?<> {loginPopUp? <div onClick={() => {dispatch({
        type: "LoginSignUpPopUp",
        
        payload:"signUp"
      });
    }}  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="TopRightNavSignUp">
     SignUp
    </div>:
             <Link to="/signup">
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="TopRightNavSignUp">
     SignUp
    </div> </Link> } {loginPopUp?
      <div onClick={() => {dispatch({
        type: "LoginSignUpPopUp",
        
        payload:"login"
      });
    }}  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="TopRightNavLogin">
     Login
    </div>:<Link to="/login">
      <div  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="TopRightNavLogin">
     Login
    </div> </Link>}</>:
    <> 
    <div onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}  className={`TopRightNavSignUp  `} onClick={logOut} >
            
            Logout
        </div> </>} 
    
               
            </div>
            
            <div className="navbar-menu-msg-outer" >
              
              <div className="navbar-menu" >
              <div className="notif-title"> 3 Messages </div>
             
              </div>
            </div> 
            </div>
  
</>
}
export  default MenuBar;